import { render, staticRenderFns } from "./pomosh-klientam.vue?vue&type=template&id=2af7288d&scoped=true"
import script from "./pomosh-klientam.vue?vue&type=script&lang=js"
export * from "./pomosh-klientam.vue?vue&type=script&lang=js"
import style0 from "./pomosh-klientam.vue?vue&type=style&index=0&id=2af7288d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7288d",
  null
  
)

export default component.exports